import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { metaDescLength, metaTitleLength } from "../../../pages/postEditor/seoAnalyzer/metaDataHelper";


export default function MetaDataCard({ analysis, content }) {
  const { t } = useTranslation();

  // Meta Title Length Calculation
  const titleLength = useMemo(() => {
    return content?.url.full ? metaTitleLength(content?.meta_title)?.score : 0;
  }, [analysis]);

  // Meta Desc Length Calculation
  const descLength = useMemo(() => {
    return content?.url.full
      ? metaDescLength(content?.meta_description)?.score
      : 0;
  }, [analysis]);

  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3">
        <div className="break-words">
          {/* Target Request in Meta Title */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Target-request-in-metatitle", "Target request in metatitle")}?
              <span
                className={`${
                  analysis?.meta_datas?.meta_title.includes_seo_request == 2
                    ? "text-green-500"
                    : analysis?.meta_datas?.meta_title.includes_seo_request == 1
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.meta_datas?.meta_title.includes_seo_request == 2
                  ? t("Yes", "Yes")
                  : analysis?.meta_datas?.meta_title.includes_seo_request == 1
                  ? t("Partially", "Partially")
                  : t("No", "No")}
              </span>
            </span>
          </div>

          {/* <eta Title Length */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("Metatitle-length", "Metatitle length")} :
              <span
                className={`${
                  titleLength == 100
                    ? "text-green-500"
                    : titleLength == 50
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.meta_datas?.meta_title?.nb_words} {t("word", "word")}
                {analysis?.meta_datas?.meta_title?.nb_words > 1
                  ? "s"
                  : ""} ( {analysis?.meta_datas?.meta_title?.nb_characters}{" "}
                {t("character", "character")}
                {analysis?.meta_datas?.meta_title?.nb_characters > 1
                  ? "s"
                  : ""}{" "}
                )
              </span>
            </span>
          </div>

          {/* Meta Title and H1 Diff */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Metatitle-different-than-H1", "Metatitle different than H1")}?
              <span
                className={`${
                  analysis?.meta_datas?.meta_title.equal_h1 == false
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {!analysis?.meta_datas?.meta_title.equal_h1
                  ? t("Yes", "Yes")
                  : t("No", "No")}
              </span>
            </span>
          </div>

          {/* Target Request in Meta Desc */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t(
                "Target-request-in-metadescription ",
                "Target request in metadescription "
              )}
              ?
              <span
                className={`${
                  analysis?.meta_datas?.meta_description.includes_seo_request ==
                  2
                    ? "text-green-500"
                    : analysis?.meta_datas?.meta_description
                        .includes_seo_request == 1
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.meta_datas?.meta_description.includes_seo_request ==
                2
                  ? t("Yes", "Yes")
                  : analysis?.meta_datas?.meta_description
                      .includes_seo_request == 1
                  ? t("Partially", "Partially")
                  : t("No", "No")}
              </span>
            </span>
          </div>

          {/* Meta Desc Length */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("Metadescription-length", "Metadescription length")} :
              <span
                className={`${
                  descLength == 100
                    ? "text-green-500"
                    : descLength == 50
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.meta_datas?.meta_description?.nb_words}{" "}
                {t("word", "word")}
                {analysis?.meta_datas?.meta_description?.nb_words > 1
                  ? "s"
                  : ""}{" "}
                ( {analysis?.meta_datas?.meta_description?.nb_characters}{" "}
                {t("character", "character")}
                {analysis?.meta_datas?.meta_description?.nb_characters > 1
                  ? "s"
                  : ""}{" "}
                )
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
